import React from "react";

function ExplanationIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C15.523 0 20 4.478 20 10C20 15.522 15.523 20 10 20C4.477 20 0 15.522 0 10C0 4.478 4.477 0 10 0ZM10 1.667C5.405 1.667 1.667 5.405 1.667 10C1.667 14.595 5.405 18.333 10 18.333C14.595 18.333 18.333 14.595 18.333 10C18.333 5.405 14.595 1.667 10 1.667ZM9.999 12.502C10.2639 12.502 10.518 12.6073 10.7054 12.7946C10.8927 12.9819 10.998 13.236 10.998 13.501C10.998 13.766 10.8927 14.02 10.7054 14.2074C10.518 14.3947 10.2639 14.5 9.999 14.5C9.73405 14.5 9.47995 14.3947 9.2926 14.2074C9.10525 14.02 9 13.766 9 13.501C9 13.236 9.10525 12.9819 9.2926 12.7946C9.47995 12.6073 9.73405 12.502 9.999 12.502ZM9.994 5C10.1754 4.99977 10.3508 5.06529 10.4876 5.18444C10.6244 5.30358 10.7133 5.46827 10.738 5.648L10.745 5.749L10.749 10.251C10.7492 10.4411 10.6772 10.6242 10.5475 10.7632C10.4179 10.9023 10.2403 10.9869 10.0506 11C9.86096 11.0131 9.67341 10.9536 9.52589 10.8337C9.37838 10.7138 9.28191 10.5423 9.256 10.354L9.249 10.252L9.245 5.751C9.24487 5.65242 9.26417 5.55479 9.3018 5.46368C9.33943 5.37257 9.39466 5.28977 9.46432 5.22002C9.53397 5.15027 9.6167 5.09494 9.70776 5.05719C9.79881 5.01943 9.89542 5 9.994 5Z"
        fill="#424242"
      />
    </svg>
  );
}

export default ExplanationIcon;
